namespace $ {
	export var $mol_http_request_native = ()=> new XMLHttpRequest;
}
